var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoaderCarousel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 200 200",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#ff5e4f",
    d: "M100,24.3c-9.5,0-17.1,7.7-17.1,17.1c0,1.4,0.2,2.8,0.5,4.1c-8.7,3.4-15.4,10.8-17.7,19.9c-1.3-0.3-2.6-0.5-4-0.5   c-9.5,0-17.1,7.7-17.1,17.1s7.7,17.1,17.1,17.1c1.4,0,2.7-0.2,4-0.5c2.3,9.2,9,16.5,17.7,19.9c-0.3,1.3-0.5,2.7-0.5,4.1   c0,9.5,7.7,17.1,17.1,17.1s17.1-7.7,17.1-17.1c0-1.4-0.2-2.8-0.5-4.1c8.7-3.4,15.4-10.8,17.7-19.9c1.3,0.3,2.6,0.5,4,0.5   c9.5,0,17.1-7.7,17.1-17.1s-7.7-17.1-17.1-17.1c-1.4,0-2.7,0.2-4,0.5c-2.3-9.2-9-16.5-17.7-19.9c0.3-1.3,0.5-2.7,0.5-4.1   C117.1,32,109.5,24.3,100,24.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ff5e4f",
    fillOpacity: 0.5,
    d: "M100,48.5c-7.9,0-14.7,4.3-18.4,10.7c-2.5-1.7-5.6-2.7-8.8-2.7c-8.7,0-15.7,7-15.7,15.7s7,15.7,15.7,15.7   c3.3,0,6.3-1,8.8-2.7c3.7,6.4,10.5,10.7,18.4,10.7s14.7-4.3,18.4-10.7c2.5,1.7,5.6,2.7,8.8,2.7c8.7,0,15.7-7,15.7-15.7   s-7-15.7-15.7-15.7c-3.3,0-6.3,1-8.8,2.7C114.7,52.8,107.9,48.5,100,48.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoaderCarousel);
export default __webpack_public_path__ + "static/media/loader-carousel.c80680561646dbe7c19b204393f8cb02.svg";
export { ForwardRef as ReactComponent };